import React from "react";
const CumulativeSpeed = () => {
  return <div> CumulativeSpeed</div>;
};
export default CumulativeSpeed;
